const isEmpty = (value: any) => {
  if (value === undefined || value === null) return true;
  return false;
};

const isTextEmpty = (value: String | string) => {
  if (value === undefined || value === null || value.trim() === "") return true;
  return false;
};

export { isEmpty, isTextEmpty};
